//insert Developers action
import usedeletedata from '../../Hooks/useDeleteData';
import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_Developers,
  Delete_Developers,
  Get_Developers,
  Get_Error,
  Get_One_Developer,
  Update_Developers,
} from '../Types';

export const InsertDevelopersData = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Developers`, body);

    dispatch({
      type: Add_Developers,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all developers

export const GetDevelopersData = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Developers?isdeveloperactivate=true`);

    dispatch({
      type: Get_Developers,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all developers not active

export const GetDevelopersDatanotactive = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Developers?isdeveloperactivate=false`);

    dispatch({
      type: Get_Developers,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//=============================================================
//get one developer data
//get all developers

export const GetOneDevelopersData = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Developers/${id}`);

    dispatch({
      type: Get_One_Developer,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//==========================================================

//update one develoeper data
export const UpdateoneDevelopersData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Developers/${id}`, body);

    dispatch({
      type: Update_Developers,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete one developer action
export const DeleteoneDevelopersData = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Developers/${id}`);

    dispatch({
      type: Delete_Developers,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
